<template>
  <div class="space-y-8">
    <SectionHeader :title="__('Internal Email Domain')">
      <template #icon>
        <Icon class="text-3xl text-primary" name="local_post_office" is-filled />
      </template>
    </SectionHeader>

    <div class="shadow-card rounded-lg bg-white px-4 py-6 md:px-6 md:py-8">
      <form @submit.prevent="handleSubmit">
        <div class="space-y-4">
            <InputText
              id="email_domains"
              v-model:value="values.domains"
              v-model:errors="errors.domains"
              :label="__('List the email domains for your company (separated by ,)')"
              :placeholder="__('Add domains')"
            />
        </div>

        <div
          class="mt-8 flex flex-col gap-2 md:flex-row-reverse items-center justify-center"
        >
          <Button
            class="flex items-center justify-center gap-1.5"
            :type="isLoading ? 'button' : 'submit'"
            :disabled="isLoading"
          >
            <Icon
              v-if="isLoading"
              class="animate-spin text-lg"
              name="progress_activity"
            />
            <span>{{ __('Save') }}</span>
          </Button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
  import { ref } from 'vue';
  import { useToast } from 'vue-toastification';
  import { __ } from '@/helpers';
  import { Button } from '@/components/block/button';
  import { Icon } from '@/components/block/icon';
  import { InputText } from '@/components/form/input-text';
  import { SectionHeader } from '@/pages/components/section-header';

  const props = defineProps({
    domains: {
      type: Object,
      required: true
    },
  });

  const toast = useToast();

  const values = ref({
    domains: props.domains || null,
  });
  const errors = ref({
    domains: [],
  });
  const isLoading = ref(false);

  async function handleSubmit() {
    const requiredFieldKeys = [
      'domains',
    ];
    let firstElement;

    requiredFieldKeys.forEach((key) => {
      if (!values.value[key]) {
        errors.value[key] = [__('This field is required')];

        const element = document.getElementById(key);

        if (element && !firstElement) {
          firstElement = element;
        }
      }
    });

    if (Object.values(errors.value).some((error) => error.length)) {
      if (firstElement) {
        firstElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      return;
    }

    isLoading.value = true;

    try {
      const response = await axios.post(
        route('redesign.company.recruiter.profile.updateInternalEmail'),
        values.value
      );

      if (response?.data?.message) {
        toast.success(response.data.message);
      }
    } catch (error) {
      if (error?.response?.data?.errors) {
        errors.value = error.response.data.errors;
      } else {
        toast.error(
          __('An unexpected error has occured. Please try again later.')
        );
      }
    }

    isLoading.value = false;
  }
</script>
